import api from '../api/material-api';

export default {
  getMaterialList (params) {
    return new Promise((resolve, reject) => {
      api.getMaterialList(params).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      });
    });
  },
  getMaterialListByUrl(url, params){
      return new Promise((resolve, reject) => {
          api.getMaterialListByUrl(url, params).then(({data}) => {
              if (data.code === 200) {
                  resolve(data.result || []);
              } else {
                  reject(data);
              }
          });
      });
  },
  getMaterialListForEditor (params) {
    return new Promise((resolve, reject) => {
      api.getMaterialListForEditor(params).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      });
    });
  },
  saveMaterial (param) {
    return new Promise((resolve, reject) => {
      api.saveMaterial(param).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    })
  },
  updateMaterial (param) {
    return new Promise((resolve, reject) => {
      api.updateMaterial(param).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    })
  },
  deleteMaterials (param) {
    return new Promise((resolve, reject) => {
      api.deleteMaterials(param).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      });
    });
  },
  getMaterialsByGroupId (id) {
    return new Promise((resolve, reject) => {
      api.getMaterialsByGroupId(id).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      });
    });
  },
  getMaterialsSize (params) {
    return new Promise((resolve, reject) => {
      api.getMaterialsSize(params).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      });
    });
  },
  batchSaveBGMaterial (param) {
    return new Promise((resolve, reject) => {
      api.batchSaveBGMaterial(param).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    })
  },
  batchSaveMaterial (param) {
    return new Promise((resolve, reject) => {
      api.batchSaveMaterial(param).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || {});
        } else {
          reject(data);
        }
      })
    })
  },
  downloadUselessMaterial (storageId) {
    return new Promise((resolve, reject) => {
      api.downloadUselessMaterial(storageId).then((response) => {
        if (response.data.type.indexOf('application/octet-stream') > -1) {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  getBgColorList (projectId, type, tplGroupIds) {
    return new Promise((resolve, reject) => {
      api.getBgColorList(projectId, type, tplGroupIds).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      });
    });
  },
  getBgColorListForEditor (projectId, type, tplGroupId) {
    return new Promise((resolve, reject) => {
      api.getBgColorListForEditor(projectId, type, tplGroupId).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      });
    });
  },
  getGroupList (projectId) {
    return new Promise((resolve, reject) => {
      api.getGroupList(projectId).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      });
    });
  },
  setGroup (projectId, params) {
    return new Promise((resolve, reject) => {
      api.setGroup(projectId, params).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      });
    });
  },
  saveGroup (params) {
    return new Promise((resolve, reject) => {
      api.saveGroup(params).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      })
    });
  },
  editThemeColor (params) {
    return new Promise((resolve, reject) => {
      api.editThemeColor(params).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      })
    });
  },
  saveBgColor (params) {
    return new Promise((resolve, reject) => {
      api.saveBgColor(params).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      })
    });
  },
  editBgColor (params) {
    return new Promise((resolve, reject) => {
      api.editBgColor(params).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      })
    });
  },
  deleteBgColor (ids) {
    return new Promise((resolve, reject) => {
      api.deleteBgColor(ids).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      })
    });
  },
  getMaterialTag (projectId) {
    return new Promise((resolve, reject) => {
      api.getMaterialTag(projectId).then(({data}) => {
        if (data.code === 200) {
          let dataList = data.result || [];
          dataList = dataList.map((tag) => {
            return {label: tag.name, value: tag.name};
          });
          resolve(dataList);
        } else {
          reject(data);
        }
      })
    });
  },
  setMaterialTag (params, projectId) {
    return new Promise((resolve, reject) => {
      api.setMaterialTag(params, projectId).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      })
    });
  },
  batchSetMaterialTag (params, projectId) {
    return new Promise((resolve, reject) => {
      api.batchSetMaterialTag(params, projectId).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      })
    });
  },
  saveMaterialForPSCache (projectId, type, data) {
    return new Promise((resolve, reject) => {
      api.saveMaterialForPSCache(projectId, type, data).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || '');
        } else {
          reject(data);
        }
      })
    });
  },
  getPSCache (userId) {
    return new Promise((resolve, reject) => {
      api.getPSCache(userId).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
  addThemeForBgImg (bgId, themeId) {
    return new Promise((resolve, reject) => {
      api.addThemeForBgImg(bgId, themeId).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
  addMaterialGroup (projectId, materialIds, tpGroup) {
    return new Promise((resolve, reject) => {
      api.addMaterialGroup(projectId, materialIds, tpGroup).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
  updateMaterialGroup (projectId, materialId, tpGroups) {
    return new Promise((resolve, reject) => {
      api.updateMaterialGroup(projectId, materialId, tpGroups).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
  addBgColorGroup (projectId, themeIds, tpGroup) {
    return new Promise((resolve, reject) => {
      api.addBgColorGroup(projectId, themeIds, tpGroup).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
  updateBgColorGroup (projectId, themeId, tpGroups) {
    return new Promise((resolve, reject) => {
      api.updateBgColorGroup(projectId, themeId, tpGroups).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
  delBgGroup (id, projectId) {
    return new Promise((resolve, reject) => {
      api.delBgGroup(id, projectId).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
  unlinkBgGroup (id, projectId) {
    return new Promise((resolve, reject) => {
      api.unlinkBgGroup(id, projectId).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
  removeMaterialGroup (projectId, id) {
    return new Promise((resolve, reject) => {
      api.removeMaterialGroup(projectId, id).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
  getYanXuanMaterialById (projectId, id) {
    return new Promise((resolve, reject) => {
      api.getYanXuanMaterialById(projectId, id).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      })
    });
  },
}